import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import Carousel from './Carousel';
import { useTypedDispatch, useTypedSelector } from 'src/redux/utils';
import { fetchHomeBanner } from 'src/redux/actions';
import { Breakpoint, useBreakpoint } from 'src/utils/breakpoints';
import { webImageUri } from 'src/utils/uri';
import CarouselPlaceHolder from './CarouselPlaceHolder';
import PageContent from 'src/Components/PageContent';
import { AppError } from 'src/redux/types';
import ErrorView from 'src/Components/ErrorViewV2';
import { ErrorViewType } from 'src/Components/ErrorViewV2/config';

const Banner = ({
  className
}) => {
  const dispatch = useTypedDispatch();
  const {
    invalidated,
    loading,
    error,
    data: banner
  } = useTypedSelector(state => state.homeBanner);
  const breakpoint = useBreakpoint();
  React.useEffect(() => {
    dispatch(fetchHomeBanner());
  }, [dispatch]);
  React.useEffect(() => {
    let timeout;

    if (banner !== null && banner !== void 0 && banner.timeout) {
      timeout = setTimeout(() => {
        dispatch(fetchHomeBanner());
      }, banner.timeout * 1000);
    }

    return () => {
      clearInterval(timeout);
    };
  }, [banner, dispatch]);
  const listBanner = (banner === null || banner === void 0 ? void 0 : banner.data.map(e => ({
    image: webImageUri(breakpoint === Breakpoint.PHONE ? e.bgImageMobile : e.bgImageDesktop),
    link: e.ctaLink
  }))) || [];

  const renderLoading = () => /*#__PURE__*/React.createElement(CarouselPlaceHolder, {
    className: styles.container
  });

  const renderContent = () => /*#__PURE__*/React.createElement(Carousel, {
    banners: listBanner
  });

  const renderError = () => {
    return /*#__PURE__*/React.createElement(ErrorView, {
      config: {
        content: 'Please try again.',
        title: 'Sorry, something went wrong.',
        type: ErrorViewType.Custom
      }
    });
  };

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, /*#__PURE__*/React.createElement(PageContent, {
    error: error !== AppError.NO_ERROR,
    loading: loading,
    invalidated: invalidated,
    renderContent: renderContent,
    renderError: renderError,
    renderLoading: renderLoading
  }));
};

export default Banner;